import React, {useEffect, useState} from 'react';
import {
    EBirdMyDataSchema,
    EBirdObservationsByLocation
} from "ebird-mydata-reader";
import {generateMarkers} from "../helpers/helpers";
import {EBirdTaxonomyEntry} from "../helpers/useEBirdTaxonomy";
import {useObservationImages} from "../helpers/useObservationImages";
import MapView from "./map-view";

export const MapMode = {
    Year: 'year',
    Species: 'species',
    Location: 'location'
}
export type MapModeType = typeof MapMode[keyof typeof MapMode];

export type MapExplorerProps = {
    observations: EBirdMyDataSchema[],
    year?: number|string,
    month?: number|string,
    observationsByLocation: EBirdObservationsByLocation[],
    onStartBigYear: () => void,
    onShowTimePeriodSelector: () => void,
    mapMode?: string,
    activeSpecies?: number,
    speciesImages: any,
    getSpeciesImages: (markers: any) => void,
    lookupByTaxonomicOrder: (taxonomicOrder: number) => EBirdTaxonomyEntry|undefined
}

export default function MapExplorer({
    observations,
    year,
    month,
    observationsByLocation,
    onStartBigYear,
    onShowTimePeriodSelector,
    mapMode,
    activeSpecies = 0,
    speciesImages,
    getSpeciesImages,
    lookupByTaxonomicOrder
}: MapExplorerProps) {
    const [markers, setMarkers] = useState<any>();
    const [activeLocation, setActiveLocation] = useState<any>();
    const { setObservationImages, setObservationImagesForMarkers } = useObservationImages(speciesImages, lookupByTaxonomicOrder);
    const resolvedMapMode = Object.values(MapMode).includes(mapMode as MapModeType)
        ? mapMode as MapModeType
        : MapMode.Year;

    useEffect(() => {
        const markers = generateMarkers(observations);

        getSpeciesImages(markers);
        setObservationImagesForMarkers(markers);
        setObservationImages(observations);
        setMarkers(markers);

    }, [getSpeciesImages, observations, setObservationImages, setObservationImagesForMarkers]);

    useEffect(() => {
        if (markers?.features?.length) {
            setObservationImagesForMarkers(markers);
        }

    }, [markers, setObservationImagesForMarkers, speciesImages]);

    if (!markers?.features?.length) {
        return null;
    }

    return (
        <>
            <MapView
                markers={markers}
                year={year}
                month={month}
                mode={resolvedMapMode}
                showPlayControls={resolvedMapMode === MapMode.Year}
                activeSpecies={activeSpecies}
                activeLocation={activeLocation}
                setActiveLocation={setActiveLocation}
                observationsByLocation={observationsByLocation}
                setObservationImages={setObservationImages}
                onShowTimePeriodSelector={onShowTimePeriodSelector}
            />
        </>
    );
}
